<template>
  <ui-component-modal
  :modalTitle="$t('Components.Spaces.ModalEditSpace.Main_Title')"
    :onClickCancel="onClickCancel"
    :showModal="showModal"
    :onClickSave="saveSpace"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :disableSaveButton="isSaving"
    @closeModal="onClickCancel"
  >
    <template v-slot:content>
      <table class="table is-striped is-fullwidth">
        <tbody>
          <tr>
            <td>
              <label
                >{{ $t('Components.Spaces.ModalEditSpace.Table_Name') }}
                <span class="has-text-danger">*</span>
              </label>
            </td>
            <td>
              <ui-base-input-field
                v-model="mSpace.Name"
                :error="nameErrors"
                :required="true"
                :showLabel="false"
                :placeholder="$t('Components.Spaces.ModalEditSpace.Table_Name')"
                fieldType="text"
                @input="$v.mSpace.Name.$touch()"
                @blur="$v.mSpace.Name.$touch()"
              />
            </td>
          </tr>
          
          <tr>
            <td>
              <label
                >{{ $t('Components.Spaces.ModalEditSpace.Table_Colour') }}
                <span class="has-text-danger">*</span>
              </label>
            </td>
            <td>
              <LvColorpicker :withoutInput="true" :value="mSpace.Colour" v-model="mSpace.Colour" />
            </td>
          </tr>

          <tr>
            <td>
              <label>{{
                $t('Components.Spaces.ModalEditSpace.Table_Nr')
              }}</label>
            </td>
            <td>
              <input
                class="input"
                type="text"
                :placeholder="$t('Components.Spaces.ModalEditSpace.Table_Nr')"
                v-model="mSpace.Number"
              />
            </td>
          </tr>
          <tr>
            <td>
              <label
                >{{ $t('Components.Spaces.ModalEditSpace.Table_Width') }}
                <span class="has-text-danger">*</span>
              </label>
            </td>
            <td>
              <div class="field has-addons">
                <p class="control">
                  <ui-base-input-field
                    v-model="mSpace.Width"
                    :error="widthErrors"
                    :required="true"
                    :showLabel="false"
                    :placeholder="
                      $t('Components.Spaces.ModalEditSpace.Table_Width')
                    "
                    fieldType="text"
                    @input="$v.mSpace.Width.$touch()"
                    @blur="$v.mSpace.Width.$touch()"
                  />
                </p>
                <p class="control">
                  <a class="button is-static">M</a>
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label
                >{{ $t('Components.Spaces.ModalEditSpace.Table_Length') }}
                <span class="has-text-danger">*</span></label
              >
            </td>
            <td>
              <div class="field has-addons">
                <p class="control">
                  <ui-base-input-field
                    v-model="mSpace.Length"
                    :error="lengthErrors"
                    :required="true"
                    :showLabel="false"
                    :placeholder="
                      $t('Components.Spaces.ModalEditSpace.Table_Length')
                    "
                    fieldType="text"
                    @input="$v.mSpace.Length.$touch()"
                    @blur="$v.mSpace.Length.$touch()"
                  />
                </p>
                <p class="control">
                  <a class="button is-static">M</a>
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label
                >{{ $t('Components.Spaces.ModalEditSpace.Table_Height') }}
                <span class="has-text-danger">*</span></label
              >
            </td>
            <td>
              <div class="field has-addons">
                <p class="control">
                  <ui-base-input-field
                    v-model="mSpace.Height"
                    :error="heightErrors"
                    :required="true"
                    :showLabel="false"
                    :placeholder="
                      $t('Components.Spaces.ModalEditSpace.Table_Height')
                    "
                    fieldType="text"
                    @input="$v.mSpace.Height.$touch()"
                    @blur="$v.mSpace.Height.$touch()"
                  />
                </p>
                <p class="control">
                  <a class="button is-static">M</a>
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label
                >{{ $t('Components.Spaces.ModalEditSpace.Table_Area') }}
                <span class="has-text-danger">*</span>
              </label>
            </td>
            <td>
              <div class="field has-addons">
                <p class="control">
                  <ui-base-input-field
                    v-model="mSpace.M2"
                    :error="m2Errors"
                    :required="true"
                    :showLabel="false"
                    :placeholder="
                      $t('Components.Spaces.ModalEditSpace.Table_Area')
                    "
                    fieldType="text"
                    @input="$v.mSpace.M2.$touch()"
                    @blur="$v.mSpace.M2.$touch()"
                  />
                </p>
                <p class="control">
                  <a class="button is-static">M2</a>
                </p>
              </div>
            </td>
          </tr>

          <tr>
            <td>{{ $t('Components.Spaces.ModalEditSpace.Table_Floor') }}</td>
            <td>
              <ui-base-input-field
                    v-model="mSpace.Floor"
                    :required="false"
                    :showLabel="false"
                    fieldType="number"
                    @input="$v.mSpace.Floor.$touch()"
                    @blur="$v.mSpace.Floor.$touch()"
                  />
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'
import spaceProvider from '@/providers/space'
import { required, minValue } from 'vuelidate/lib/validators'
import LvColorpicker from 'lightvue/color-picker';
const touchMap = new WeakMap()

export default {
  components: {
    LvColorpicker
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isSaving: false,
      isSavingError: false,
      isSavingSuccess: false,
      mSpace: null,
    }
  },

  //form field validations
  validations: {
    mSpace: {
      Name: {
        required,
      },
      M2: {
        required,
        minValue: minValue(1),
      },
      Width: {
        required,
        minValue: minValue(1),
      },
      Length: {
        required,
        minValue: minValue(1),
      },
      Height: {
        required,
        minValue: minValue(0),
      },
    },
  },

  computed: {
    ...mapState('spaceStore', ['space']),

    nameErrors() {
      const errors = []
      if (!this.$v.mSpace.Name.$dirty) return errors
      if (!this.$v.mSpace.Name.required) {
        errors.push(this.$t('Form.InputErrors.Required'))
      }
      return errors
    },

    widthErrors() {
      const errors = []
      if (!this.$v.mSpace.Width.$dirty) return errors
      if (!this.$v.mSpace.Width.required) {
        errors.push(this.$t('Form.InputErrors.Required'))
      } else if (!this.$v.mSpace.Width.minValue) {
        errors.push(this.$t('Form.InputErrors.InCorrect'))
      }
      return errors
    },

    lengthErrors() {
      const errors = []
      if (!this.$v.mSpace.Length.$dirty) return errors
      if (!this.$v.mSpace.Length.required) {
        errors.push(this.$t('Form.InputErrors.Required'))
      } else if (!this.$v.mSpace.Length.minValue) {
        errors.push(this.$t('Form.InputErrors.InCorrect'))
      }
      return errors
    },

    heightErrors() {
      const errors = []
      if (!this.$v.mSpace.Height.$dirty) return errors
      if (!this.$v.mSpace.Height.required) {
        errors.push(this.$t('Form.InputErrors.Required'))
      } else if (!this.$v.mSpace.Height.minValue) {
        errors.push(this.$t('Form.InputErrors.InCorrect'))
      }
      return errors
    },

    m2Errors() {
      const errors = []
      if (!this.$v.mSpace.M2.$dirty) return errors
      if (!this.$v.mSpace.M2.required) {
        errors.push(this.$t('Form.InputErrors.Required'))
      } else if (!this.$v.mSpace.M2.minValue) {
        errors.push(this.$t('Form.InputErrors.InCorrect'))
      }
      return errors
    },
  },

  created() {
    this.mSpace = JSON.parse(JSON.stringify(this.space))
  },

  methods: {
    ...mapMutations('spaceStore', ['setSpace']),

    saveSpace() {
      let self = this
      self.isSaving = true
      self.isSavingSuccess = false
      self.isSavingError = false

      this.$v.$touch()
      if (this.$v.$invalid) {
        // 'ERROR'
        self.isSaving = false
      } else {
        spaceProvider.methods
          .updateSpace(self.mSpace)
          .then((response) => {
            if (response.status === 200) {
              self.mSpace = response.data
              self.setSpace(self.mSpace)

              self.$emit('spaceEdited', self.mSpace)

              // Send message to display toast on screen
              EventBus.$emit('showToast', {
                type: 'info',
                message: 'Space updated',
              })

              self.onClickCancel()
            }
          })
          .catch((e) => {
            self.isSavingError = true
          })
          .finally(() => {
            self.isSaving = false
          })
      }
    },
  },
}
</script>
